export default "__VITE_ASSET__ccb40260__"